import { render, staticRenderFns } from "./PayPalWebHook.vue?vue&type=template&id=671cb58c"
import script from "./PayPalWebHook.vue?vue&type=script&lang=js"
export * from "./PayPalWebHook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports